import Icon from "@bokio/designsystem/components/Icon/Icon";
import ModalBase from "@bokio/designsystem/components/Modal/ModalBase";
import { Article, Heading, Section } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import { noop } from "@bokio/shared/utils";
import { mergeClassNames } from "@bokio/utils/classes";

import { getBackgroundColorClass, getGraphic, getImageClassName, getSizeClassName } from "./fancyModal.utils";

import type {
	FancyModalBackgroundColor,
	FancyModalGraphic,
	FancyModalImageSize,
	FancyModalWidth,
} from "./fancyModal.utils";
import type { FC, PropsWithChildren } from "react";

import * as styles from "./fancyModal.scss";

interface FancyModalProps {
	title: string;
	visible: boolean;
	onClose: () => void;
	backgroundColor?: FancyModalBackgroundColor;
	graphic?: FancyModalGraphic;
	customGraphic?: string;
	imageSize?: FancyModalImageSize;
	width?: FancyModalWidth;
	testId?: string;
}

export const FancyModal: FC<PropsWithChildren<FancyModalProps>> = ({
	title,
	visible,
	onClose,
	children,
	width,
	testId,
	backgroundColor,
	graphic,
	customGraphic,
	imageSize,
}) => {
	return (
		<ModalBase
			testId={testId}
			title=""
			visible={visible}
			autoFocus={false}
			onBackgroundClick={noop}
			onCloseButtonClick={noop}
			onEscape={noop}
			className={mergeClassNames(styles.modal, getBackgroundColorClass(backgroundColor || "white"))}
			width={width}
			alwaysMounted={false}
		>
			<div className={styles.closeWrapper}>
				<button
					onClick={onClose}
					className={styles.closeButton}
					type="button"
					data-testid={testId && `${testId}_CloseButton`}
				>
					<Icon name="cancel" className={styles.closeIcon} />
				</button>
			</div>
			<Section>
				<div className={mergeClassNames(styles.content, getSizeClassName(width))}>
					<Article resetHeadingLevelTo={1}>
						<Heading style="large-heading">{title}</Heading>
						{children}
					</Article>
					<div className={styles.imageContainer}>
						<img
							src={customGraphic || getGraphic(graphic)}
							aria-hidden="true"
							className={getImageClassName(imageSize || "medium")}
						/>
					</div>
				</div>
			</Section>
		</ModalBase>
	);
};
